import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2, Lock } from "lucide-react";
import { API, setSession, formatApiError } from "@/lib/auth";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setError("");
    setSubmitting(true);
    try {
      const { data } = await axios.post(`${API}/admin/login`, { email, password });
      setSession(data.token, data.email);
      nav("/admin", { replace: true });
    } catch (err) {
      setError(formatApiError(err?.response?.data?.detail));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main
      data-testid="admin-login-page"
      className="min-h-screen bg-ink text-white flex items-center justify-center px-6 py-16"
    >
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <a href="/" className="font-display text-2xl tracking-tight text-white">
            J<span className="text-brass">.</span>J<span className="text-brass">.</span> Botelho
          </a>
          <p className="overline text-brass mt-6 justify-center inline-flex">Admin</p>
          <h1 className="mt-4 font-display text-white text-4xl sm:text-5xl tracking-tight">
            Sign in.
          </h1>
        </div>

        <form
          onSubmit={submit}
          data-testid="admin-login-form"
          className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-8 space-y-5"
        >
          <div>
            <label className="text-xs uppercase tracking-widest text-white/70 mb-2 block">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-email-input"
              className="w-full bg-ink/60 border border-white/20 rounded-md px-4 py-3 text-white focus:outline-none focus:border-brass"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-white/70 mb-2 block">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-password-input"
              className="w-full bg-ink/60 border border-white/20 rounded-md px-4 py-3 text-white focus:outline-none focus:border-brass"
            />
          </div>

          {error && (
            <p data-testid="admin-login-error" className="text-red-300 text-sm">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center gap-2 bg-brass text-ink py-3 rounded-full text-sm font-semibold tracking-wide hover:bg-white transition-colors disabled:opacity-60"
          >
            {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />}
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </main>
  );
}
